import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
      © Michael Fang 2019 
    </div>
  )
}

export default Footer
